import { createContext, useContext } from "react";

import type { OrgChartContextValue } from "../types";

const OrgChartContext = createContext<OrgChartContextValue | undefined>(
  undefined
);

export default OrgChartContext;

/** Returns undefined when rendered outside OrgChartContextProvider (e.g. person hierarchy chart). */
export const useOptionalOrgChartContext = ():
  | OrgChartContextValue
  | undefined => useContext(OrgChartContext);

export const useOrgChartContext = (): OrgChartContextValue => {
  const context = useOptionalOrgChartContext();

  if (context === undefined) {
    throw new Error(
      "useOrgChartContext must be used within OrgChartContextProvider"
    );
  }

  return context;
};
